export default {
  Climb: {
    optimistic: () => {
      return false;
    },
  },
};
